<template>
  <v-container fluid class="language-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/language/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="languages-table"
              show-select
              single-select
              item-key="_id"
              sort-by="languagename"
              :footer-props="footer"
              :headers="headers"
              :items="languages"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Language?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteLanguage.languagename }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteLanguage)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.languageimage" size="35">
                  <img v-bind:src="item.languageimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.languagename[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.languagename="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.languagename }}</a></p>
                <p class="two-line">{{ item.languageinfo }}</p>
              </template>
              <template v-slot:item.languagestatus="{ item }">
                <v-chip
                  :color="!item.languagestatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.languagestatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'languageList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteLanguage: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Code', value: 'languagecode' },
        { text: 'Name', value: 'languagename' },
        { text: 'Status', value: 'languagestatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    }
  },
  computed: {
    ...mapState('Language', ['languages', 'isReceiving', 'isDeleting', 'idToDelete', 'languagesMessage', 'isUpdating']),
  },
  created () {
    this.getLanguagesRequest()
  },
  methods: {
    ...mapActions('Language', ["getLanguagesRequest","deleteLanguageRequest",]),
    editItem(item) {
      this.$router.push({ name: 'LanguageEdit', params: item })
    },
    deleteItem(item) {
      this.deleteLanguageRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteLanguage = {
        _id: item._id,
        languagename: item.languagename,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
